export default "__VITE_ASSET__1f58af2c__"